import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_crm/crm/events")({
  beforeLoad: ({ context }) => guardRoute(context.me, "crm-events"),
  component: Outlet,
});
